import TempoAPI from './TempoAPI'

export default class ArticlesAPI extends TempoAPI
{
    constructor()
    {
        super();
        this.serviceName = 'get_posts';
    }
    getPosts(limit, offset, handler)
    {
        const data = {
            type: 'article',
            limit: limit,
            offset: offset
        }
        /* this.makeAPICall(this.serviceName, data, handler); */

this.makeAPICall(this.serviceName, data, (response) => {
    console.log('Articles API response:', response); // Agrega esto
    handler(response);
  });

    }
}